import { useQuery } from "@tanstack/react-query";
import notificationService from "../../../services/notificationService";
import { NotificationInterface } from "../../../models/notification";
import { CACHE_KEY_TICKETNOTIFICATION } from "../../../utils/constants";

const useTicketNotification = () =>
  useQuery<NotificationInterface[], Error>({
    queryKey: [CACHE_KEY_TICKETNOTIFICATION],
    queryFn: notificationService.Get,
  });

export default useTicketNotification;
